// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>3</span>&nbsp;&nbsp;&#145;Let us break their bonds asunder&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and cast away their cords from us.&#146;<br> </p> </div></div>";
// Exports
module.exports = code;